import "./Coverage.module.css";
import Header from "@/reusable_sections/Header";
import MontrealsTrustedShine from "./sections/MontrealsTrustedShine";
import GlobalReach from "./sections/GlobalReach";
import CommonQuestions from "./sections/CommonQuestions";
import Footer from "@/reusable_sections/Footer";
export default function CoveragePage() {
  return <div>
      <Header />
      <MontrealsTrustedShine />
      <GlobalReach />
      <CommonQuestions />
      <Footer />
    </div>;
}